// extracted by mini-css-extract-plugin
export default {"imgdiv":"_74da1b77e0 _5679cd2271","img":"_59d6aecab0 db24ea29f5"};